import MaorCredit from "./MaorCredit";

export default MaorCredit;